// extracted by mini-css-extract-plugin
export default {"spinner":"spinner_spinner__ceNjm","preloader":"spinner_preloader__iPJdg","loader":"spinner_loader__p-JFj","spin":"spinner_spin__T-ntE"};